// @flow
import React from 'react';

import {
  GroupByPicker,
} from 'chronos-components';

import {
  Col,
} from '../styled';
import {
  Header,
  HeaderContainer,
  GroupBy,
  ColText,
} from './styled';

function capitalizeFirstLetter(str: string) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

const pixel = new Image();
pixel.src = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=';

type Props = {
  style: Object,
  groupBy: string,
  isGroupByOpen: boolean,
  onGroupBy: { (): void },
  setGroupByVisible: (value: boolean) => void,
  listResizeRequest: { (): void },
};

const ListHeaderCellRenderer = (props: Props) => {
  const {
    style,
    groupBy,
    onGroupBy,
    isGroupByOpen,
    setGroupByVisible,
    listResizeRequest,
  } = props;

  return (
    <Header style={style}>
      <HeaderContainer>
        <Col size="50%">
          <GroupBy>
            {capitalizeFirstLetter(groupBy)}
          </GroupBy>
          <GroupByPicker
            isOpen={isGroupByOpen}
            groupBy={groupBy}
            onGroupBy={onGroupBy}
            setPopupVisible={setGroupByVisible}
          />
        </Col>
        <Col size="20%"><ColText>Key</ColText></Col>
        <Col size="50px"><ColText>Σ</ColText></Col>
      </HeaderContainer>
    </Header>
  );
};

ListHeaderCellRenderer.defaultProps = {
};

export default ListHeaderCellRenderer;
